var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Carousel extends Component {
    constructor() {
        super('Carousel', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            console.log('Carousel component initialized');
            $('.carousel').each((carousel) => {
                new BS_Carousel(carousel.get(0));
            }).on('slid.bs.carousel', (event) => {
                const carousel = $(event.target);
                const carouselCaptions = carousel.parents('.gallery-parent').find('.gallery-caption');
                carouselCaptions.addClass('d-none');
                carouselCaptions.eq(carousel.find('.carousel-item.active').index()).removeClass('d-none');
            });
            this.success();
        });
    }
}
